import posthog, { type PostHogInterface } from 'posthog-js'

declare global {
  interface Window {
    POSTHOG_PROJECT_TOKEN?: string
    posthog?: PostHogInterface
  }
}

function initPosthog() {
  const token = window.POSTHOG_PROJECT_TOKEN
  if (!token) return

  window.analytics.ready(() => {
    posthog.init(token, {
      api_host: 'https://ph.resemble.ai',
      ui_host: 'https://us.posthog.com',
      defaults: '2026-06-25',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- @types/segment-analytics and posthog-js's own Segment types are independently authored and don't structurally match, though both describe the same window.analytics object.
      segment: window.analytics as any,
      // Cookieless mode (advanced_disable_decide, etc.) is a marketing-site-only
      // setting - do not enable it here. The app relies on PostHog's normal
      // persistent cookie/identity handling, sharing the `.resemble.ai` cookie
      // with the marketing site. A signed-in app user who then visits the
      // marketing site will see that cookie's identity flip to an anonymous
      // id - that's expected, not a bug to work around.
      //
      // analytics.page() is intentionally not called here - it's already
      // invoked from within analytics.ready() in
      // _segment_user_identification.html.erb for signed-in users, and
      // calling it again here would double-count that pageview.
      capture_pageview: false,
      capture_pageleave: true,
      // Identified-rate events only for now at launch; revisit after a billing cycle.
      autocapture: false,
      // This PostHog project has session replay enabled project-wide at 100%
      // sampling for the marketing site. Without this flag, every app session
      // would start being recorded (and billed) the moment this deploys - app
      // replay will be turned on deliberately later with its own sampling rate.
      disable_session_recording: true,
      loaded: (ph) => {
        window.posthog = ph
      },
    })
  })
}

if (window.analytics) {
  initPosthog()
} else {
  let retriesLeft = 100
  const interval = setInterval(() => {
    retriesLeft--
    if (window.analytics) {
      clearInterval(interval)
      initPosthog()
    } else if (retriesLeft <= 0) {
      clearInterval(interval)
      console.error('[PostHog] Segment analytics never became available; PostHog will not load.')
    }
  }, 100)
}
